/**
 * Localization fallback for CMS-managed entities: use a translated field only when
 * it is a non-empty string; otherwise keep the English source value.
 * List fields (e.g. included items) are stored translated as newline-separated text.
 */
export function localize<T extends Record<string, unknown>>(source: T, translated: Record<string, unknown> | null | undefined, listFields: (keyof T)[] = []): T {
  if (!translated) return source;
  const out: Record<string, unknown> = { ...source };
  for (const [k, v] of Object.entries(translated)) {
    if (!(k in source) || typeof v !== "string" || !v.trim()) continue;
    if (listFields.includes(k as keyof T)) {
      const items = v.split("\n").map((s) => s.trim()).filter(Boolean);
      const src = source[k] as unknown[];
      // Only accept a translated list that keeps the same number of items, so facts are not dropped.
      if (Array.isArray(src) && items.length === src.length) out[k] = items;
    } else out[k] = v;
  }
  return out as T;
}

/** Share of translatable fields that have a non-empty translation (fields empty in English are ignored). */
export function completeness(source: Record<string, unknown>, translated: Record<string, unknown> | null | undefined, fields: string[]): { done: number; total: number } {
  const relevant = fields.filter((f) => { const v = source[f]; return Array.isArray(v) ? v.length > 0 : typeof v === "string" && v.trim() !== ""; });
  const done = relevant.filter((f) => typeof translated?.[f] === "string" && String(translated[f]).trim() !== "").length;
  return { done, total: relevant.length };
}
